import * as React from 'react';
type Props = {
  className?: string;
};
export function Sunrise({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-sunrise"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 18V20H3.00003V18H21ZM12 10C15.0617 10 17.7805 11.8469 18.9244 14.6185L17.0757 15.3815C16.2387 13.3535 14.2462 12 12 12C9.75381 12 7.76141 13.3535 6.92439 15.3815L5.07566 14.6185C6.21954 11.8469 8.93835 10 12 10ZM4.1591 5.9421L7.37304 9.77232L5.84095 11.0579L2.62701 7.22768L4.1591 5.9421ZM19.841 5.9421L21.373 7.22768L18.1591 11.0579L16.627 9.77232L19.841 5.9421ZM13 4V9H11V4H13Z"
        fill="currentColor"
      />
    </svg>
  );
}
